import React from 'react';
import { Box, Typography } from '@mui/material';
import { IconCustom } from '../IconCustom/IconCustom';

interface BadgeEventFlagProps {
  label: string;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
}

export const BadgeEventFlag: React.FC<BadgeEventFlagProps> = ({
  label,
  backgroundColor = '#F3F3F7',
  borderColor = '#DBDCE8',
  textColor = '#000'
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '24px',
        width: 'fit-content',
        borderRadius: '4px',
        px: '8px',
        backgroundColor,
        border: `1px solid ${borderColor}`

      }}
    >
      <IconCustom type={label} />
      <Typography
        variant="body2"
        sx={{
          textTransform: 'capitalize',
          color: textColor
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}; 